export default "__VITE_ASSET__$qlexTAO__"